<template>
  <div class="retailTile relative flex flex-direction-column">
    <div class="retailTile--image-container flex-grow">
      <div class="overlay"></div>
      <router-link :to="{ path: data.link.replace('https://bulletin.co', '') }" class="block">
        <img
          v-if="data.thumbnail_image_url"
          :src="`https://bulletin.co/cdn-cgi/image/width=556,quality=100,format=auto/${data.thumbnail_image_url}`"
        />
        <div v-else class="image-placeholder icon-upload-image"></div>
      </router-link>
    </div>
    <div class="retailTile--description-container width-100 mt-20 mt-40-sm">
      <router-link
        :to="{ path: data.link.replace('https://bulletin.co', '') }"
        class="mr-20 mb-5-sm mr-0-sm block font-size-16 cambon-book-sm"
      >
        {{ data.name }}
        <h4 class="black mt-5 mt-15-sm mb-10 mb-10-sm font-size-9-sm mr-0-sm mr-20">${{ data.mov }} minimum</h4>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base/vars.scss";
@import "../../../assets/sass/base/helpers.scss";
.retailTile {
  .retailTile--image-container {
    position: relative;
    .overlay {
      pointer-events: none;
      cursor: pointer;
      opacity: 0;
      position: absolute;
      width: 100%;
      height: 50%;
      top: 50%;
      background: linear-gradient(to bottom, transparent, #d3b6fe);
      -webkit-transition: all 0.2s ease;
      -moz-transition: all 0.2s ease;
      -o-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
      object-fit: cover;
    }
    .image-placeholder {
      height: 100%;
      background-size: 50%;
      background-position: center;
    }
  }
  &:hover .retailTile--image-container .overlay {
    opacity: 0.7;
  }
  .retailTile--description-container {
    position: relative;
    h4,
    a {
      -webkit-transition: all 0.2s ease;
      -moz-transition: all 0.2s ease;
      -o-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }
    @include respond-to("small") {
      text-align: center;
    }
  }
  &:hover .retailTile--description-container {
    h4,
    a {
      opacity: 0.7;
    }
  }
  .favorite--wrapper {
    position: absolute;
    right: 0px;
    top: 0px;
  }
}
</style>
